import React from "react"
import IntersectionVisible from 'components/IntersectionVisible'
import UGCVideoUploadStep from "steps/ugc-video-upload/UGCVideoUploadStep"

const sanitizeCustomJSON =(stepData) => {
    let customJson = JSON.parse(stepData.customJson)
    let videoShareStep = customJson
    return {videoShareStep}
}

const CustomJSONStep = ({ breakId, step, onEngage = function() {}, onAwardPoints = function() {}, userType, service, nextStepButton, themeColors, skipButton }) => {
    
    const stepSanitized = sanitizeCustomJSON(step)
    console.log(stepSanitized)
    
    return (
        <>
            <section className={`custom-json`}>
                <div className={`step-content ${stepSanitized.backgroundImage ? " with-shadow" : ""}`}>
                    <div className="custom-json__content">
                        {/* <h2 dangerouslySetInnerHTML={{__html: step.filtering.headline}} />
                        <p dangerouslySetInnerHTML={{ __html: step.filtering.introCopy }} /> */}
                        <UGCVideoUploadStep 
                            breakId={breakId} 
                            step={stepSanitized.videoShareStep}
                            onEngage={onEngage}
                            onAwardPoints={onAwardPoints}
                            userType={userType}
                            service={service}
                            nextStepButton={nextStepButton}
                            skipButton={skipButton} 
                            themeColors={themeColors}/>
                    </div>
            {skipButton}
            {nextStepButton}
                </div>
            </section>
               
   
        </>
      )
}

export default CustomJSONStep